/* Local-only numerical tools. No network or storage. */
(function (root, factory) {
    'use strict';
    if (typeof module === 'object' && module.exports) module.exports = factory(require('./edukacja-matematyka.js'));
    else root.PewniakiStatystyka = factory(root.PewniakiEdukacja);
}(typeof window !== 'undefined' ? window : globalThis, function (M) {
    'use strict';
    function values(text) {
        if (!String(text).trim()) throw Error('data');
        var tokens = String(text).trim().split(/[;\s]+/);
        if (tokens.length > 10000) throw Error('limit');
        return tokens.map(function (s) { var x = M.number(s); if (Math.abs(x) > 1e9) throw Error('range'); return x; });
    }
    function describe(text, binCount) {
        var data = values(text), s = M.stats(text), bins = Number(binCount === '' || binCount === undefined ? Math.min(10, Math.ceil(Math.sqrt(s.n))) : binCount);
        if (!Number.isInteger(bins) || bins < 1 || bins > 50) throw Error('bins');
        if (s.min === s.max) bins = 1;
        var width = (s.max - s.min) / bins;
        s.bins = Array.from({length: bins}, function (_, i) { return {from: s.min + i * width, to: i === bins - 1 ? s.max : s.min + (i + 1) * width, count: 0}; });
        data.forEach(function (x) { s.bins[width ? Math.min(bins - 1, Math.floor((x - s.min) / width)) : 0].count++; });
        s.mean = data[0] + data.reduce(function (sum, x) { return sum + (x - data[0]) / s.n; }, 0);
        s.ss = data.reduce(function (sum, x) { return sum + (x - s.mean) ** 2; }, 0);
        s.variance = s.ss / s.n; s.sd = Math.sqrt(s.variance);
        s.sampleVariance = s.n > 1 ? s.ss / (s.n - 1) : null;
        s.sampleSd = s.sampleVariance === null ? null : Math.sqrt(s.sampleVariance);
        s.data = data;
        return s;
    }
    function frequency(text) {
        var data = values(text).sort(function (a, b) { return a - b; }), rows = [], cumulative = 0;
        data.forEach(function (value) {
            var last = rows[rows.length - 1];
            if (last && last.value === value) last.count++;
            else rows.push({value: value, count: 1});
        });
        rows.forEach(function (row) {
            cumulative += row.count;
            row.relative = row.count / data.length;
            row.cumulative = cumulative;
            row.cumulativeRelative = cumulative / data.length;
        });
        return {n: data.length, distinct: rows.length, rows: rows};
    }
    function scatter(xText, yText) {
        var x = values(xText), y = values(yText), n = x.length;
        if (n !== y.length || n < 2) throw Error('pairs');
        var mx = x[0] + x.reduce(function (s, v) { return s + (v - x[0]) / n; }, 0), my = y[0] + y.reduce(function (s, v) { return s + (v - y[0]) / n; }, 0);
        var xx = 0, yy = 0, xy = 0;
        x.forEach(function (v, i) { xx += (v - mx) ** 2; yy += (y[i] - my) ** 2; xy += (v - mx) * (y[i] - my); });
        var slope = xx ? xy / xx : null;
        return {n: n, x: x, y: y, meanX: mx, meanY: my, r: xx && yy ? Math.max(-1, Math.min(1, xy / Math.sqrt(xx * yy))) : null, slope: slope, intercept: slope === null ? null : my - slope * mx};
    }
    // Composite Simpson integration of the standard normal density, step <= 0.005.
    // Tail is integrated directly to avoid cancellation near 1. Domain [-10, 10].
    function tail(z) {
        if (!Number.isFinite(z) || Math.abs(z) > 10) throw Error('zrange');
        if (z < 0) return 1 - tail(-z);
        if (z === 0) return 0.5;
        var end = 12, n = Math.ceil((end - z) / 0.005); if (n % 2) n++;
        var h = (end - z) / n, sum = 0;
        for (var i = 0; i <= n; i++) { var v = z + i * h; sum += (i === 0 || i === n ? 1 : i % 2 ? 4 : 2) * Math.exp(-v * v / 2) / Math.sqrt(2 * Math.PI); }
        return sum * h / 3;
    }
    function normal(z, upper) {
        z = M.number(z); upper = M.number(upper);
        if (z > upper) throw Error('order');
        var left = tail(-z), right = tail(z), area = z >= 0 ? tail(z) - tail(upper) : upper <= 0 ? tail(-upper) - tail(-z) : 1 - tail(-z) - tail(upper);
        return {z: z, upper: upper, left: left, right: right, between: Math.max(0, area)};
    }
    function zscore(x, mean, sd) {
        x = M.number(x); mean = M.number(mean); sd = M.number(sd);
        if (sd <= 0 || Math.max(Math.abs(x), Math.abs(mean), sd) > 1e9) throw Error('range');
        var z = (x - mean) / sd;
        if (!Number.isFinite(z)) throw Error('range');
        return z;
    }
    function valueFromZ(z, mean, sd) {
        z = M.number(z); mean = M.number(mean); sd = M.number(sd);
        if (sd <= 0 || Math.abs(z) > 10 || Math.max(Math.abs(mean), sd) > 1e9) throw Error('range');
        var value = mean + z * sd;
        if (!Number.isFinite(value) || Math.abs(value) > 1e10) throw Error('range');
        return value;
    }
    function probabilityTree(pA, pBgA, pBgNotA) {
        pA = M.number(pA); pBgA = M.number(pBgA); pBgNotA = M.number(pBgNotA);
        if ([pA, pBgA, pBgNotA].some(function (p) { return p < 0 || p > 1; })) throw Error('probability');
        var notA = 1 - pA;
        var paths = [
            {path: 'A ∩ B', probability: pA * pBgA},
            {path: 'A ∩ ¬B', probability: pA * (1 - pBgA)},
            {path: '¬A ∩ B', probability: notA * pBgNotA},
            {path: '¬A ∩ ¬B', probability: notA * (1 - pBgNotA)}
        ];
        return {pA: pA, pBgA: pBgA, pBgNotA: pBgNotA, pB: paths[0].probability + paths[2].probability, paths: paths};
    }
    function stemLeaf(text, unit) {
        var data = values(text); unit = M.number(unit);
        if (![0.1, 1, 10].includes(unit) || data.some(function (value) { return value < 0; })) throw Error('stemleaf');
        var groups = new Map(), rounded = false;
        data.forEach(function (value) {
            var scaled = value / unit, integer = Math.round(scaled);
            if (Math.abs(scaled - integer) > 1e-9) rounded = true;
            var stem = Math.floor(integer / 10), leaf = integer - stem * 10;
            if (!groups.has(stem)) groups.set(stem, []);
            groups.get(stem).push(leaf);
        });
        var rows = Array.from(groups.keys()).sort(function (a, b) { return a - b; }).map(function (stem) {
            var leaves = groups.get(stem).sort(function (a, b) { return a - b; });
            return {stem: stem, leaves: leaves, count: leaves.length};
        });
        return {n: data.length, unit: unit, rounded: rounded, rows: rows};
    }
    function confidenceZ(level) {
        level = M.number(level);
        var values = {'0.9': 1.6448536269514722, '0.95': 1.959963984540054, '0.99': 2.5758293035489004};
        var z = values[String(level)];
        if (!z) throw Error('confidence');
        return z;
    }
    function normalDistribution(mean, sd, lower, upper) {
        mean = M.number(mean); sd = M.number(sd); lower = M.number(lower); upper = M.number(upper);
        if (sd <= 0 || lower > upper || Math.max(Math.abs(mean), Math.abs(lower), Math.abs(upper), sd) > 1e9) throw Error('normal');
        var za = (lower - mean) / sd, zb = (upper - mean) / sd;
        if (za < -10 || zb > 10) throw Error('normal');
        var standard = normal(za, zb);
        return {mean:mean, sd:sd, lower:lower, upper:upper, zLower:za, zUpper:zb, left:standard.left, between:standard.between, right:tail(zb)};
    }
    function inverseNormal(probability, mean, sd) {
        probability = M.number(probability); mean = M.number(mean); sd = M.number(sd);
        if (!(probability > 0 && probability < 1) || sd <= 0 || Math.max(Math.abs(mean), sd) > 1e9) throw Error('inverse-normal');
        var lo = -10, hi = 10;
        for (var i = 0; i < 100; i++) {
            var mid = (lo + hi) / 2;
            if (tail(-mid) < probability) lo = mid; else hi = mid;
        }
        var z = (lo + hi) / 2, x = mean + z * sd;
        if (!Number.isFinite(x) || Math.abs(x) > 1e10) throw Error('inverse-normal');
        return {probability:probability, mean:mean, sd:sd, z:z, x:x};
    }
    function logChoose(n, k) {
        k = Math.min(k, n - k); var value = 0;
        for (var i = 1; i <= k; i++) value += Math.log(n - k + i) - Math.log(i);
        return value;
    }
    function binomialPmf(n, p, k) {
        if (p === 0) return k === 0 ? 1 : 0;
        if (p === 1) return k === n ? 1 : 0;
        return Math.exp(logChoose(n, k) + k * Math.log(p) + (n - k) * Math.log1p(-p));
    }
    function binomial(n, p, k) {
        n = M.number(n); p = M.number(p); k = M.number(k);
        if (!Number.isInteger(n) || n < 1 || n > 1000 || !Number.isInteger(k) || k < 0 || k > n || p < 0 || p > 1) throw Error('binomial');
        var rows = [], atMost = 0, below = 0;
        for (var i = 0; i <= n; i++) {
            var probability = binomialPmf(n, p, i);
            if (i <= k) atMost += probability;
            if (i < k) below += probability;
            rows.push({k:i, probability:probability});
        }
        return {n:n,p:p,k:k,exact:rows[k].probability,atMost:Math.min(1,atMost),atLeast:Math.min(1,Math.max(0,1-below)),mean:n*p,variance:n*p*(1-p),sd:Math.sqrt(n*p*(1-p)),rows:rows};
    }
    function logGamma(z) {
        var c=[0.99999999999980993,676.5203681218851,-1259.1392167224028,771.32342877765313,-176.61502916214059,12.507343278686905,-0.13857109526572012,9.9843695780195716e-6,1.5056327351493116e-7];
        if(z<0.5)return Math.log(Math.PI)-Math.log(Math.sin(Math.PI*z))-logGamma(1-z);
        z-=1;var x=c[0];for(var i=1;i<c.length;i++)x+=c[i]/(z+i);var t=z+7.5;
        return 0.5*Math.log(2*Math.PI)+(z+0.5)*Math.log(t)-t+Math.log(x);
    }
    function betaFraction(a,b,x){
        var qab=a+b,qap=a+1,qam=a-1,c=1,d=1-qab*x/qap;if(Math.abs(d)<1e-30)d=1e-30;d=1/d;var h=d;
        for(var m=1;m<=200;m++){var m2=2*m,aa=m*(b-m)*x/((qam+m2)*(a+m2));d=1+aa*d;if(Math.abs(d)<1e-30)d=1e-30;c=1+aa/c;if(Math.abs(c)<1e-30)c=1e-30;d=1/d;h*=d*c;aa=-(a+m)*(qab+m)*x/((a+m2)*(qap+m2));d=1+aa*d;if(Math.abs(d)<1e-30)d=1e-30;c=1+aa/c;if(Math.abs(c)<1e-30)c=1e-30;d=1/d;var next=d*c;h*=next;if(Math.abs(next-1)<3e-12)break;}return h;
    }
    function regularizedBeta(x,a,b){
        if(x<=0)return 0;if(x>=1)return 1;var front=Math.exp(logGamma(a+b)-logGamma(a)-logGamma(b)+a*Math.log(x)+b*Math.log1p(-x));
        return x<(a+1)/(a+b+2)?front*betaFraction(a,b,x)/a:1-front*betaFraction(b,a,1-x)/b;
    }
    function studentTCdf(t,df){var x=df/(df+t*t),half=0.5*regularizedBeta(x,df/2,0.5);return t>=0?1-half:half;}
    function studentT(df,lower,upper){
        df=M.number(df);lower=M.number(lower);upper=M.number(upper);
        if(!Number.isInteger(df)||df<1||df>1000000||lower>upper||Math.max(Math.abs(lower),Math.abs(upper))>100)throw Error('student-t');
        var left=studentTCdf(lower,df),up=studentTCdf(upper,df);
        return {df:df,lower:lower,upper:upper,left:left,between:Math.max(0,up-left),right:Math.max(0,1-up)};
    }
    var tCritical95 = [0,12.706,4.303,3.182,2.776,2.571,2.447,2.365,2.306,2.262,2.228,2.201,2.179,2.160,2.145,2.131,2.120,2.110,2.101,2.093,2.086,2.080,2.074,2.069,2.064,2.060,2.056,2.052,2.048,2.045,2.042];
    var tCritical90 = [0,6.314,2.920,2.353,2.132,2.015,1.943,1.895,1.860,1.833,1.812,1.796,1.782,1.771,1.761,1.753,1.746,1.740,1.734,1.729,1.725,1.721,1.717,1.714,1.711,1.708,1.706,1.703,1.701,1.699,1.697];
    var tCritical99 = [0,63.657,9.925,5.841,4.604,4.032,3.707,3.499,3.355,3.250,3.169,3.106,3.055,3.012,2.977,2.947,2.921,2.898,2.878,2.861,2.845,2.831,2.819,2.807,2.797,2.787,2.779,2.771,2.763,2.756,2.750];
    function tCritical(level, df) {
        var table = String(level) === '0.9' ? tCritical90 : String(level) === '0.95' ? tCritical95 : String(level) === '0.99' ? tCritical99 : null;
        if (!table || !Number.isInteger(df) || df < 1) throw Error('confidence');
        if (df <= 30) return table[df];
        var z = confidenceZ(level), z2=z*z, z3=z2*z, z5=z3*z2, z7=z5*z2;
        return z + (z3+z)/(4*df) + (5*z5+16*z3+3*z)/(96*df*df) + (3*z7+19*z5+17*z3-15*z)/(384*df*df*df);
    }
    function confidenceMean(mean, sd, n, level) {
        mean=M.number(mean); sd=M.number(sd); n=M.number(n); level=M.number(level);
        if (!Number.isInteger(n) || n<2 || n>10000000 || sd<=0 || Math.max(Math.abs(mean),sd)>1e9) throw Error('confidence');
        var critical=tCritical(level,n-1), se=sd/Math.sqrt(n), margin=critical*se;
        return {type:'mean',mean:mean,sd:sd,n:n,level:level,critical:critical,se:se,margin:margin,lower:mean-margin,upper:mean+margin,df:n-1};
    }
    function confidenceProportion(successes, total, level) {
        successes=M.number(successes); total=M.number(total); level=M.number(level);
        if (!Number.isInteger(total) || total<1 || total>10000000 || !Number.isInteger(successes) || successes<0 || successes>total) throw Error('confidence');
        var z=confidenceZ(level), p=successes/total, z2=z*z, denom=1+z2/total, center=(p+z2/(2*total))/denom, margin=z*Math.sqrt(p*(1-p)/total+z2/(4*total*total))/denom;
        return {type:'proportion',successes:successes,n:total,level:level,p:p,critical:z,center:center,margin:margin,lower:Math.max(0,center-margin),upper:Math.min(1,center+margin)};
    }
    function sampleSizeProportion(level, marginPercent, p, population) {
        level=M.number(level); marginPercent=M.number(marginPercent); p=M.number(p);
        var margin=marginPercent/100, z=confidenceZ(level);
        if (margin<=0 || margin>=1 || p<=0 || p>=1) throw Error('sample');
        var raw=z*z*p*(1-p)/(margin*margin), adjusted=raw, N=null;
        if (String(population).trim() !== '') { N=M.number(population); if(!Number.isInteger(N)||N<1) throw Error('sample'); adjusted=raw/(1+(raw-1)/N); }
        return {type:'proportion',level:level,z:z,margin:margin,p:p,population:N,raw:raw,n:Math.ceil(adjusted)};
    }
    function sampleSizeMean(level, margin, sigma) {
        level=M.number(level); margin=M.number(margin); sigma=M.number(sigma); var z=confidenceZ(level);
        if (margin<=0 || sigma<=0 || Math.max(margin,sigma)>1e9) throw Error('sample');
        var raw=(z*sigma/margin)**2;
        return {type:'mean',level:level,z:z,margin:margin,sigma:sigma,raw:raw,n:Math.ceil(raw)};
    }
    // Explicit delimiter; optional one-row header. Numeric cells only, no formulas.
    function csv(text, delimiter, columns, header) {
        if (text.length > 1000000 || ![';', ',', '\t'].includes(delimiter)) throw Error('csv');
        var lines = text.replace(/^\uFEFF/, '').trim().split(/\r?\n/);
        if (header) lines.shift();
        if (!lines.length || lines.length > 10000) throw Error('csv');
        var result = Array.from({length: columns}, function () { return []; });
        lines.forEach(function (line) {
            var cells = line.split(delimiter);
            if (cells.length !== columns) throw Error('csv');
            cells.forEach(function (cell, i) {
                cell = cell.trim(); if (/^"[^"]*"$/.test(cell)) cell = cell.slice(1, -1);
                var n = M.number(cell); if (Math.abs(n) > 1e9) throw Error('range'); result[i].push(n);
            });
        });
        return result.map(function (a) { return a.join('; '); });
    }
    function percentile(text, p) {
        var data = values(text).sort(function (a, b) { return a - b; }); p = M.number(p);
        if (p < 0 || p > 100) throw Error('percentile');
        var h = (data.length - 1) * p / 100, lo = Math.floor(h), hi = Math.ceil(h);
        return {p: p, value: data[lo] + (h - lo) * (data[hi] - data[lo]), position: h + 1, lower: data[lo], upper: data[hi], weight: h - lo};
    }
    function venn(a, b) {
        function parse(text) {
            if (String(text).length > 20000) throw Error('sets');
            var tokens = String(text).split(/[;\n]+/).map(function (s) { return s.trim().normalize('NFC'); }).filter(Boolean);
            if (tokens.length > 500 || tokens.some(function (s) { return s.length > 80; })) throw Error('sets');
            return Array.from(new Set(tokens));
        }
        var A = parse(a), B = parse(b), sa = new Set(A), sb = new Set(B);
        return {a: A, b: B, both: A.filter(function (x) { return sb.has(x); }), onlyA: A.filter(function (x) { return !sb.has(x); }), onlyB: B.filter(function (x) { return !sa.has(x); }), union: Array.from(new Set(A.concat(B)))};
    }
    function birthday(n, days) {
        n = M.number(n); days = M.number(days);
        if (!Number.isInteger(n) || n < 0 || n > 10000 || !Number.isInteger(days) || days < 1 || days > 366) throw Error('birthday');
        if (n < 2) return 0;
        if (n > days) return 1;
        var log = 0; for (var i = 1; i < n; i++) log += Math.log1p(-i / days);
        return -Math.expm1(log);
    }
    function boxplot(text) {
        var s = describe(text), sorted = s.data.slice().sort(function (a, b) { return a-b; });
        s.lowerFence = s.q1 - 1.5*s.iqr; s.upperFence = s.q3 + 1.5*s.iqr;
        var inside = sorted.filter(function (x) { return x >= s.lowerFence && x <= s.upperFence; });
        s.lowerWhisker = inside[0]; s.upperWhisker = inside[inside.length-1];
        return s;
    }
    function weighted(text, weightsText) {
        var x = values(text), w = values(weightsText);
        if (x.length !== w.length || w.some(function (v) { return v < 0; })) throw Error('weights');
        var total = w.reduce(function (a,b) { return a+b; },0);
        if (!total) throw Error('weights');
        var sum = x.reduce(function (a,v,i) { return a+v*w[i]; },0);
        return {n:x.length, totalWeight:total, weightedSum:sum, mean:sum/total, x:x, weights:w};
    }
    function variation(text, sample, ratioScale) {
        if (!ratioScale) throw Error('ratio');
        var s = describe(text), sd = sample ? s.sampleSd : s.sd;
        if (s.min < 0 || s.mean <= 0 || sd === null) throw Error('cv');
        return {mean:s.mean, sd:sd, cv:100*sd/s.mean, n:s.n};
    }
    return {values: values, describe: describe, frequency: frequency, scatter: scatter, normal: normal, normalDistribution:normalDistribution, inverseNormal:inverseNormal, studentT:studentT, binomial:binomial, confidenceMean:confidenceMean, confidenceProportion:confidenceProportion, sampleSizeProportion:sampleSizeProportion, sampleSizeMean:sampleSizeMean, zscore: zscore, valueFromZ: valueFromZ, probabilityTree: probabilityTree, stemLeaf: stemLeaf, tail: tail, csv: csv, percentile: percentile, venn: venn, birthday: birthday, boxplot:boxplot, weighted:weighted, variation:variation};
}));
